module.exports = __webpack_public_path__ + "img/harvelles-6.27.25.1476791b.png";